<table>
  <thead>
  <th colspan="2">User right groups</th>
  </thead>
  <thead>
  <th></th>
  <th>Name</th>
  </thead>
  <tr *ngFor="let group of groups">
    <th><input type="checkbox" (change)="selectGroup(group)" [(ngModel)]="group.selected"></th>
    <th>{{group.name}}</th>
  </tr>
</table>
